import React, { Fragment, useState } from "react";
import { useOutletContext } from "react-router-dom";
import AdministrationHeader from "../../components/header-components/AdministrationHeader.jsx";
import { KPI } from "../../components/KPI.js";
import UntaggedOverviewTable from "./UntaggedOverviewTable.jsx";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useKeycloak } from "@react-keycloak/web";


const API_URL = process.env.REACT_APP_API_URL;

const UntaggedOverview = () => {
	const [aggregatedCosts, setAggregatedCosts] = useState({});
	const [costAggregates, setCostAggregates] = useState({});
	const { keycloak } = useKeycloak();

	const { startDate,  endDate } = useOutletContext();


	const retrieveUntaggedOverview = async(token) => {
		if (token === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + token);

		let method = "GET";

		let requestOptions = {
			method: method,
			headers: headers,
		};

		const response = await fetch(API_URL + "/get-tag-keys-overview?startDate=" + dayjs(startDate).format("YYYY-MM-DD") + "&endDate=" + dayjs(endDate).format("YYYY-MM-DD"), requestOptions);

		if (!response.ok) {
			throw new Error("Failed to fetch data");
		}

		return response.json();
	}

	useQuery(
		["untaggedOverview"],
		() => retrieveUntaggedOverview(keycloak.token),
		{
			onSuccess: (data) => {		
                // Sort alphabetically but put "Untagged" at the bottom
                const sortedData = [...data.TagKeysOverview].sort((a, b) => {
                    if (a.tag_key === "Untagged") return 1;
                    if (b.tag_key === "Untagged") return -1;
                    return a.tag_key.localeCompare(b.tag_key);
                });

                setCostAggregates({
					total_cost: sortedData[0].total_cost,
                    total_resources: sortedData[0].total_resources,
				});

                setAggregatedCosts(sortedData);
			},
			enabled: keycloak.token !== "",
			staleTime: 5000, // Optional: Prevent frequent refetching
		}
	);

	return (
		<Fragment>
            <AdministrationHeader
				title="Tagging Policy"
                subTitle="Define and manage the tags that are used in the different cloud environments"
				className="text-text-3"
				icon={icon({name: "tags", style: "light"})}
			/>
			<div className="text-left flex flex-auto flex-col ml-10 mt-4 border-solid border-border">
				<div className="flex flex-row gap-4">
					<div className="flex-shrink-0">
						<KPI
							title="Total Cost"
							currentValue={costAggregates.total_cost}
							format="currency"
							showChange={false}
						/>
					</div>

					<div className="flex-shrink-0">
						<KPI
							title="Total Resources"
							currentValue={costAggregates.total_resources}
							format="decimal"
							showChange={false}
						/>
					</div>
				</div>

				<div className="bg-card border border-card-bd pt-4 pb-2 my-2 rounded-card h-screen flex flex-auto flex-col">
					<UntaggedOverviewTable
						data={aggregatedCosts}
						expandAll={true}
						totalCost={costAggregates.cost}
					/>
				</div>
			</div>
		</Fragment>
	);
};

export default UntaggedOverview;
